import { UrlHashesFragments, UrlGetParams } from 'consts'
import isRecommendedProduct from 'utils/isRecommendedProduct'

const shouldChatWidgetOpen = () => {
  const urlHash = window.location.hash
  const urlParams = new URLSearchParams(window.location.search)
  const getParams = Array.from(urlParams.keys())

  if (isRecommendedProduct(urlParams)) {
    return true
  }

  return (
    urlHash.indexOf(UrlHashesFragments.SupportChat) !== -1 ||
    urlHash.indexOf(UrlHashesFragments.SupportChatNotifications) !== -1 ||
    getParams.includes(UrlGetParams.SupportChat) ||
    getParams.includes(UrlGetParams.SupportChatNotifications) ||
    getParams.includes(UrlGetParams.ViewProduct)
  )
}

export default shouldChatWidgetOpen
